import React from 'react'
import Fragment from '../common/fragment'


function FragmentBJ(props) {
  return (
    <Fragment pos="jj" {...props}>
      <p>
El Muñeco será la flor más dulce/Un jardín para seres que vuelan//Una colmena
desterrada/Un duelo zigzagueante///Quien no vuele como las abejas/Nunca sabrá lo
que es la dulzura////El Muñeco resucitará después de 3 días/Pero no sabemos
dónde/Nadie será testigo de su regreso/Las abejas lo estarán esperando para
empezar de nuevo/A polinizar la muerte/La única vegetación de estos parajes///La
única colmena.
      </p>
    </Fragment>
  )
}


export default FragmentBJ
